import styled from "@emotion/styled";
import { DropdownInline } from "src/atoms/DropDown";

export const SortDropdown = styled(DropdownInline)`
  padding-left: 24px;
  > .text {
    margin: 0 16px 0 0;
    font-weight: 600;

    &.default {
      color: ${({ theme }) => theme.colors?.tone.black};
    }
  }

  i.icon {
    &:before {
      background-color: ${({ theme }) => theme.colors?.tone.black};
    }
  }

  .menu {
    position: absolute;

    &.visible {
      width: 250px;
      padding: ${({ theme }) => theme.space?.space8} 0;
    }

    .item {
      padding: 4px 32px 4px 16px;
      white-space: nowrap;

      .text {
        font-weight: 600;
      }
    }
  }
`;
